// mui
import Container from '@mui/material/Container';
//
import { Helmet } from 'react-helmet-async';
// sections
import ChiTietAnPham from 'src/sections/chi-tiet-an-pham/chi-tiet-an-pham';

// ----------------------------------------------------------------------

export default function Page() {
  return (
    <>
      <Helmet>
        <title> Tên ấn phẩm </title>
      </Helmet>

      <Container>
        <ChiTietAnPham />
      </Container>
    </>
  );
}
